module.exports = __webpack_public_path__ + "img/profile-man-5-min.fed74f95.jpg";